import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash'
    import Invoice from '../../module/common/models/Invoice.ts';
    import PdfLineItem from '../../module/pdf/types/PdfLineItem.ts';
    import { ref, computed, watch, inject, useTemplateRef, onMounted, nextTick } from 'vue';

    interface Props {
        invoice: Invoice | null,
    }
    
    
export default /*@__PURE__*/_defineComponent({
  __name: 'invoice_comparison',
  props: {
    invoice: { type: [Object, null], required: true }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

    const com_purchase_order_line_items = computed(() => {
        return props.invoice?.purchase_order_line_items ?? []
    })

    const get_matching_po_item = function(arg_purchase_order_items: PdfLineItem[], arg_line_item: PdfLineItem) {
        return arg_purchase_order_items.find((tmp_line_item: PdfLineItem) => {
            return arg_line_item.part_name == tmp_line_item.part_name
        })
    }

    const line_item_has_discrepancy = function(arg_purchase_order_items: PdfLineItem[], arg_line_item: PdfLineItem) {
        const matching_item = get_matching_po_item(arg_purchase_order_items, arg_line_item)
        if (!matching_item) {
            return false
        }

        return (
            arg_line_item.quantity !== matching_item.quantity
            || arg_line_item.price_per_unit !== matching_item.price_per_unit
            || arg_line_item.line_item_total !== matching_item.line_item_total
        )
    }

    function is_numeric(str: number | string): boolean {
        if (typeof str == "number") return true
        if (typeof str != "string") return false // we only process strings!  
        return !isNaN(str as unknown as number) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
            !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    }

    function display_currency(money: number | string): string {
        if(typeof money == "undefined"
            || money === null
            || !is_numeric(money)
        ) {
            return ""
        }

        if (typeof money === "string") {
            money = parseFloat(money)
        }

        return money.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
        });
    }

    const props = __props
    watch(() => props.invoice, () => {
        console.log("props.invoice", props.invoice)
    })
    

const __returned__ = { com_purchase_order_line_items, get_matching_po_item, line_item_has_discrepancy, is_numeric, display_currency, props }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})